import { Box, Stack, styled } from '@/theme/index';

export const StyledBox = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  border: '1px solid #FFFFFF1A',
  padding: `${theme.spacing(4.75)} ${theme.spacing(3)} ${theme.spacing(4.25)}`,
  backgroundColor: '#FFFFFF1F',
  borderBottomLeftRadius: '4px',
  borderBottomRightRadius: '4px',
}));

export const StyledStack = styled(Stack)(() => ({
  '&:not(:last-child)': {
    paddingBottom: '1rem',
  },
}));
